/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-02 10:04:48
 */
import { defineMessages } from 'react-intl';

const messageObject = {
  title: '欢迎使用supOS运维平台',
  username: '用户名',
  usernameNull: '请输入用户名',
  password: '密码',
  passwordNull: '请输入密码',
  rememberUsername: '记住用户名',
  login: '登录',
};

export default defineMessages(messageObject);
